module.exports = __webpack_public_path__ + "88bdbd1a9983782d1402622a08296e7f.svg";